export const persist = {
  title: 'Keep your log from being cleared',
  body: (n: number) =>
    `You have ${n} ${n === 1 ? 'entry' : 'entries'} saved on this phone. Phones sometimes clear app data on their own to free up space. You can tell your browser to leave this alone.`,
  // Named plainly, because the browser dialog that follows cannot be
  // reworded and "persistent storage" means nothing to most people.
  whatHappensNext: 'Your browser will ask you to confirm. Choose Allow.',
  confirm: 'Protect my log',
  asking: 'Asking…',
  notNow: 'Not now',
  granted: 'Your log is protected on this phone.',
  declined:
    'No problem. You can turn this on any time in Settings, and saving a backup file works just as well.',
};
